import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M15.042 3.32208C15.779 4.05887 16.3636 4.9337 16.7625 5.89648C17.1614 6.85926 17.3667 7.89116 17.3667 8.9333C17.3667 9.97545 17.1614 11.0074 16.7625 11.9702C16.3636 12.933 15.779 13.8077 15.042 14.5445C13.5542 16.0314 11.5368 16.8667 9.43336 16.8667C7.32993 16.8667 5.31256 16.0314 3.82474 14.5445C3.08773 13.8077 2.50306 12.933 2.10418 11.9702C1.70529 11.0074 1.5 9.97545 1.5 8.9333C1.5 7.89116 1.70529 6.85926 2.10418 5.89648C2.50306 4.9337 3.08773 4.05887 3.82474 3.32208C5.31256 1.83519 7.32993 1 9.43336 1C11.5368 1 13.5542 1.83519 15.042 3.32208V3.32208Z",
			fill: "none",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5016 17.9996L15.1016 14.5996",
			fill: "none",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
